import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { CONTACT_SPOUSE_RELATION_CODE } from '@/views_v2/verify-credit/types';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'ContactRelation' })
export default class ContactRelation extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | string;

  private contactRelation: undefined | number | null = null;

  /** 是否不能选配偶(自营-晋商未婚) */
  @Prop(Boolean) readonly isDisableEmergency!: boolean;


  /** 外部传入，更改提示 */
  @Prop(String)
  private outErrorMsg!: string;

  private originalOptions: OptionItem[] = [];

  private get contactRelationOptions(): OptionItem[] {
    if (this.isDisableEmergency) {
      /** 删除关系：配偶 */
      return this.originalOptions.filter((it) => it.code !== CONTACT_SPOUSE_RELATION_CODE);
    }
    return this.originalOptions;
  }

  private errorMsg = '';

  private async created() {
    if (this.value) {
      this.contactRelation = Number(this.value);
    }

    const options = await DictApi.getContactRelations();

    this.originalOptions = options;

    if (this.outErrorMsg) {
      /** 错误信息赋值 */
      this.errorMsg = this.outErrorMsg || '';
      /** 表单数据重置 */
      this.contactRelation = undefined;
    }
  }

  @Watch('value')
  private onValueChange(val: number | string | undefined) {
    if (val !== this.contactRelation) {
      this.contactRelation = Number(val);
    }
  }

  public onValidator(): boolean {
    if (this.contactRelation === null || typeof this.contactRelation === 'undefined') {
      this.errorMsg = '请选择您与联系人的关系';
      return false;
    }
    return true;
  }

  private onContactRelation(val: string | undefined | null | number) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  /** 配偶关系时，不可选 */
  private get getSpouseDisabled(): boolean {
    return !this.isDisableEmergency && this.contactRelation === CONTACT_SPOUSE_RELATION_CODE;
  }

  private render() {
    return (
      <div class={this.getSpouseDisabled ? style.LockEmergencyRelation : null}>
        <Field
          v-model={this.contactRelation}
          label="关系"
          sub={true}
          disabled={this.getSpouseDisabled}
          onChange={() => this.onContactRelation(this.contactRelation)}
          type="select"
          options={this.contactRelationOptions}
          error={this.errorMsg}
          class={style.emergency}
          readonly={true}
        />
      </div>
    );
  }
}
